<template>

  <mdc-textfield class="list-search"
                 type="text"
                 :name="name"
                 ref="input_search"
                 id="input_search"
                 :disabled="disabled"
                 :label="placeholder"
                 v-bind:value="value"
                 v-on:keyup.enter="onEnter"
                 v-on:blur="onEnter"/>

</template>

<script>
  export default {
    name: 'Search',
    props: {
      placeholder: {
        type: String,
        default: () => {
          return ''
        },
      },
      value: {
        type: String,
        default: () => {
          return ''
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: 'list-search',
      },
    },
    methods: {
      'onEnter': function (event) {

        if (event && event.which == 13) {
          let input = this.$refs['input_search'];
          input.blur();
        }

        if (event && event.type == 'blur') {
          let value = event.target.value;
          this.$emit('enter', value)
        }



      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/table/Search.vue